import React from "react";
import { Helmet } from "react-helmet-async";
import { inject } from "mobx-react";
import { Container } from "reactstrap";
import { SeoBlockContainer } from "Containers/SeoBlock";
import {
	InfoBlockContainer,
	ProvidersLogoContainer,
	CertificatesContainer,
} from "Containers/BlockContainers";
import SeoBlockHOC from "HOC/SeoBlockHOC";

const AboutCompany = (props) => {
	const {
		ApplicationModel: { siteConfig },
		route,
	} = props;
	const canonical = () => {
		let location = "/about/company";

		return (
			<Helmet>
				<link
					rel="canonical"
					href={`${siteConfig.ssl === true ? `https` : "http"}://${
						siteConfig.domain_name_full
					}${location}`}
				/>
			</Helmet>
		);
	};

	return (
		<>
			{canonical()}
			<Container>
				<SeoBlockContainer route={route} placeText="Greetings" />
				<SeoBlockContainer route={route} placeText="Achievements" bgText={true} />
				<SeoBlockHOC route={route} placeText="Providers">
					<ProvidersLogoContainer />
				</SeoBlockHOC>
				<SeoBlockContainer route={route} placeText="SearchByAddress" />
				<InfoBlockContainer />
				<SeoBlockHOC route={route} placeText="Certificates">
					<CertificatesContainer />
				</SeoBlockHOC>
				<SeoBlockContainer route={route} placeText="Charity" />
				<SeoBlockContainer route={route} placeText="Facts" bgText={true} />
				<SeoBlockContainer route={route} placeText="Choice" />
				<SeoBlockContainer route={route} placeText="PS" />
			</Container>
		</>
	);
};

export default inject("ApplicationModel")(AboutCompany);
